module.exports = __webpack_public_path__ + "static/media/EnglishRosesInMorning.23febaa5.jpg";